import { render } from "./CodeScreen.vue?vue&type=template&id=fed8ea00&scoped=true&lang=html"
import script from "./CodeScreen.vue?vue&type=script&lang=js"
export * from "./CodeScreen.vue?vue&type=script&lang=js"

import "./CodeScreen.vue?vue&type=style&index=0&id=fed8ea00&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/visma_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fed8ea00"]])

export default __exports__